<template>
  <s-task-list-layout
    :title="$t('Training.TrainingApply')"
    history-u-r-l="/tasklist/trainingHistory"
  >
    <s-training-list :items="activeItems" />
    <template v-slot:toolbarExtension>
      <s-internal-proposal />
    </template>
  </s-task-list-layout>
</template>

<script>

import STaskListLayout from './components/STaskListLayout'
import SInternalProposal from './components/SInternalProposal'
import STrainingList from './components/STrainingList'
import { mapState } from 'vuex'
import store from '../../store'
import { trainingTLModule } from '../../store/moduleName'

// We're dynamically registering the
// `taskList` store module. This has
// the benefit of only loading this
// module, if it's actually needed.
// Before registering the module, we're
// checking if it's already registered
// which can happen in combination with
// webpacks hot reloading.
if (!store.state[trainingTLModule]) store.registerModule(trainingTLModule)

export default {
  components: {
    STaskListLayout,
    SInternalProposal,
    STrainingList
  },
  computed: {
    ...mapState({
      activeItems: state => state[trainingTLModule].classSummariesActiveItems
    })
  },
  created () {
    this.$store.dispatch(trainingTLModule + '/getClassSummariesActiveItems')
  }
}
</script>
